// extracted by mini-css-extract-plugin
module.exports = {"root":"Upload__root--DIGlD Layout__form--4yOS_"};